import { Component, inject, OnInit, DestroyRef } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '@core/auth/services/auth.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs';
import { ThemeService } from '@core/services/theme.service';
import { footerCopyright, footerItems } from '@core/config/footer-items.config';
import { navbarVerticalItems } from '@core/config/navbar-vertical-items.config';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HeaderComponent } from '@shared/components/header/header.component';
import { MovingBackgroundComponent } from '@shared/components/moving-background/moving-background.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet, HeaderComponent, MovingBackgroundComponent]
})
export class AppComponent implements OnInit {
    protected readonly authService = inject(AuthService);
    private readonly router = inject(Router);
    private readonly translateService = inject(TranslateService);
    private readonly pageTitleService = inject(Title);
    private readonly themeService = inject(ThemeService);
    private readonly destroyRef = inject(DestroyRef);

    protected readonly navbarVerticalItems = navbarVerticalItems;
    protected readonly footerCopyright = footerCopyright;
    protected readonly footerItems = footerItems;

    public ngOnInit(): void {
        this.initializeTheme();
        this.subscribeToLanguageChanges();
        this.updatePageTitleTranslation();
    }

    protected isRouterPathUnauthorized(): boolean {
        return this.router.url === '/auth/unauthorized';
    }

    protected isRouterPathNotFound(): boolean {
        return this.router.url === '/not-found';
    }

    private initializeTheme(): void {
        this.themeService.initialize();
    }

    private updatePageTitleTranslation(): void {
        this.pageTitleService.setTitle(this.translateService.instant('page-titles.home'));
    }

    private subscribeToLanguageChanges(): void {
        this.translateService.onLangChange
            .pipe(
                tap(() => this.updatePageTitleTranslation()),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe();
    }
}
